<div class="layout-sidebar surface-card" (mouseenter)="expandMenu()" (mouseleave)="collapseMenu()"
  [ngClass]="{'layout-sidebar-expanded': isExpanded || isPinned}">
  <div class="flex align-items-center justify-content-between px-3 pt-3 pb-2">
    <div class="flex align-items-center gap-2">
      <i class="pi pi-truck" style="font-size: xx-large;"></i>
      <span class="font-medium text-xl sidebar-text">Dispatch Hub</span>
    </div>
    <button *ngIf="isExpanded || isPinned" pButton class="p-button-text p-button-rounded p-button-sm"
      icon="pi pi-thumbtack" [style]="isPinned ? 'color: var(--primary-color)' : 'color: var(--secondary-color)' "
      (click)="togglePin($event)">
    </button>
  </div>
  <p-menu [model]="menuItems" [styleClass]="'w-full-full border-none'"></p-menu>
  <div class="sidebar-logout">
    <button pButton class="p-button-text w-full flex align-items-center gap-2 logout-btn"
      [label]="(isExpanded || isPinned) ? 'Logout' : ''" [pTooltip]="!(isExpanded || isPinned) ? 'Logout' : ''"
      tooltipPosition="right" (click)="logout()">
      <i class="pi pi-sign-out"></i>
    </button>
  </div>
</div>